<template lang="pug">
    include Discounts.pug
</template>

<script>
import { mapState } from 'vuex';
import Api from "@/components/services/Api";
import PrivateRouterLink from '@/directives/PrivateRouterLink'

export default {
  name: 'Discounts',
  components: {PrivateRouterLink},
  computed: mapState([
    "context", "token",
  ]),
  data () {
    return {
      limit: 5,
      page: 1,
      selectVisible: false,
      hasPrevious: false,
      hasNext: true,
      totalPages: 1,
      pages: [],
      discounts: [],
      categories: [],
      selectedCategory: null,
      plan: null,
    }
  },
  async created() {
    const _this = this

    const meResponse = await Api.me(this.token)
    const meData = meResponse.data
    this.plan = meData.plan

    const categoriesResponse = await this.$wagtail.getDiscountCategories()
    const data = categoriesResponse.data
    this.categories = data

    this.page = 1
    this.search()
  },
  methods: {
    search: function() {
      const _this = this

      let page = this.page
      let plan = this.plan

      let filters = {page, plan}
      if (this.selectedCategory) {
        filters.category = this.selectedCategory.slug
      }

      _this.$wagtail.getDiscounts(5, filters).then(response => {
        let data = response.data
        _this.discounts = data.results
        _this.hasPrevious = data.has_previous
        _this.hasNext = data.has_next
        _this.totalPages = data.pages

        let pagesList = []

        for (var i = 1; i <= _this.totalPages; i++) {
          pagesList.push(i)
        }
        _this.pages = pagesList
      }).catch(err => {
      })
    },
    nextPage() {
      if (!this.hasNext) return false
      this.page += 1
      this.search()
    },
    prevPage() {
      if (!this.hasPrevious) return false
      this.page -= 1
      this.search()
    },
    toPage(page) {
      this.page = page
      this.search()
    },
  },
  watch: {
    selectedCategory: function(newVal) {
      this.selectedCategory = newVal
      this.search()
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";

@import "Discounts";

</style>



// WEBPACK FOOTER //
// src/components/discounts/Discounts.vue